(function() {
  'use strict';

  /**
   * @ngdoc function
   * @name webAgro1App.controller:RecomendacaoSemeaduraTratamentoCtrl
   * @description
   * # RecomendacaoSemeaduraTratamentoCtrl
   * Controller of the webAgro1App
   */
  angular
    .module('webAgro1App')
    .controller('RecomendacaoSemeaduraTratamentoCtrl', RecomendacaoSemeaduraTratamento);

  /**
   * RecomendacaoSemeaduraController dependencies
   * @type {Array}
   */
  RecomendacaoSemeaduraTratamento.$inject = [
    '$scope',
    'LoadingService',
    'MessagesService',
    'RecomendacoesSemeaduraService',
    'filterFilter',
    'UnidadesService',
    'ProdutoModalService',
    'RecomendacoesService'
  ];

  /**
   * RecomendacaoSemeaduraTratamento declaration
   */
  // eslint-disable-next-line max-lines-per-function, max-params
  function RecomendacaoSemeaduraTratamento($scope, LoadingService, MessagesService, MIN_DOSE_VALOR,
    filterFilter, UnidadesService, ProdutoModalService, RecomendacoesService) {
    const vm = this;

    //////////////////////////////////////////
    // Controller data
    // temporary placeholder for new tratamento
    vm.recomendacao = {};
    vm.cultivaresTratamento = [];
    vm.cultivaresDestinoTratamento = [];
    vm.cultivaresDestinoDisponivel = [];
    vm.isCorn = false;
    vm.tempTratamento = null;
    vm.tempInsumo = null;
    vm.editing = false;
    vm.tratamentos = [];
    vm.produtos = [];
    vm.produto = {};

    //////////////////////////////////////////
    // Bindable methods
    vm.editTratamento = editTratamento;
    vm.cancelEditTratamento = cancelEditTratamento;
    vm.deleteTratamento = deleteTratamento;
    vm.kgTratamentoExceeded = kgTratamentoExceeded;
    vm.addTratamentoDisabled = addTratamentoDisabled;
    vm.setAttributesCultivar = setAttributesCultivar;
    vm.addTratamento = addTratamento;
    vm.searchCultivaresTratamento = searchCultivaresTratamento;
    vm.searchProdutos = searchProdutos;
    vm.addProduto = addProduto;
    vm.removeProduto = removeProduto;
    vm.setUnidadeProduto = setUnidadeProduto;
    vm.validateProdutos = validateProdutos;
    vm.openProductModal = openProductModal;
    vm.totalAplicado = totalAplicado;
    vm.canCopy = canCopy;
    vm.canSelectCultivarDestino = canSelectCultivarDestino;

    //////////////////////////////////////////
    // Function declarations
    function cancelEditTratamento(tratamento) {
      delete tratamento.editing;
      vm.editing = false;
      vm.tempTratamento = null;
    }

    function editTratamento(tratamento) {
      tratamento.editing = true;
      vm.editing = true;
      vm.tempTratamento = tratamento;
    }

    function deleteTratamento(index) {
      vm.recomendacao.tratamentos.splice(index, 1);
    }

    function kgTratamentoExceeded() {
      if ((vm.tempTratamento || {}).cultivar) {
        let sum = 0;
        sum = vm.totalAplicado();
        sum += vm.tempTratamento.totalKg;

        return (sum > +vm.tempTratamento.cultivar.totalKg.toFixed(2)) &&
          sum > +(vm.tempTratamento.cultivar.totalKg + vm.tempTratamento.cultivar.totalKgTSI).toFixed(2);
      }
      return false;
    }

    function totalAplicado() {
      return vm.recomendacao.tratamentos.reduce(function(last, current) {
        last += (current.cultivar.item_id === vm.tempTratamento.cultivar.item_id &&
          !current.editing) ? (+current.totalKg) : 0.00;
        return last;
      }, 0.00) || 0.00;
    }

    /**
     * Returns wether a new tratamento can be added
     * @return {Boolean}
     */
    function addTratamentoDisabled() {
      return !vm.tempTratamento || !vm.tempTratamento.cultivar ||
        !vm.tempTratamento.totalKg;
    }

    function setAttributesCultivar() {
      let kgAplicar;

      if (vm.tempTratamento.cultivar.totalKgTSI) {
        kgAplicar = vm.tempTratamento.cultivar.totalKgTSI +
          vm.tempTratamento.cultivar.totalKg - vm.totalAplicado();
      } else {
        kgAplicar = vm.tempTratamento.cultivar.totalKg - vm.totalAplicado();
      }

      vm.cultivaresDestinoDisponivel = vm.cultivaresDestinoTratamento
        .filter((cultivarDestino) => cultivarDestino.codigo_semente_origem === vm.tempTratamento.cultivar.item_id);
      vm.tempTratamento.cultivarDestino = {};

      if (vm.cultivaresDestinoDisponivel.length === 1) {
        vm.tempTratamento.cultivarDestino = vm.cultivaresDestinoDisponivel[0];
      }

      if (!vm.cultivaresDestinoDisponivel.length) {
        vm.tempTratamento.cultivarDestino = vm.tempTratamento.cultivar;
      }

      vm.tempTratamento.totalKg = kgAplicar >= 0 ? parseFloat(kgAplicar.toFixed(2)) : 0;
    }

    function addTratamento() {
      delete vm.tempTratamento.editing;
      if (!vm.editing) {
        if (vm.tempTratamento.copyFrom) {
          vm.tempTratamento.insumos = angular.copy(vm.tempTratamento.copyFrom.insumos);
          delete vm.tempTratamento.copyFrom;
        } else {
          vm.tempTratamento.insumos = [];
        }
        vm.recomendacao.tratamentos.push(vm.tempTratamento);
      }
      vm.editing = false;
      vm.tempTratamento = null;
    }

    function searchCultivaresTratamento($select) {
      if (!$select.search || $select.search.length < 3) {
        return;
      }
      return RecomendacoesService.listItemsBalance({
        operacao_item: 'cultivar',
        descricao: $select.search
      }).then(function(result) {
        vm.cultivaresTratamento = result.data.map(function(data) {
          return { ...data, item_id: data.id, item_tipo: data.tipo || 1 };
        });
      })
        .catch(function(error) {
          console.error('Falha ao buscar sementes de origem', error);
        });
    }

    function searchProdutos($select, tratamento) {
      const searchProduto = $select.search;
      vm.produtos = null;
      if (searchProduto.length >= 3) {
        tratamento.loadingProdutos = true;
        RecomendacoesService.listItemsBalance({
          descricao: $select.search,
          operacao_item: 'pulverizacao'
        }).then(function(data) {
          vm.produtos = data.data || [];
        })
          .catch(function(error) {
            console.error('Erro ao buscar produtos', error);
            MessagesService.alert('Erro ao carregar produtos');
          })
          .finally(function() {
            delete tratamento.loadingProdutos;
          });
      }
    }

    // TODO: rever complexity
    // eslint-disable-next-line complexity
    function addProduto($select, tratamento) {
      if ($select && $select.id) {
        const produto = filterFilter(tratamento.insumos, { id: $select.id }, true) || [];
        const produtoOtherCultivar = _.chain(vm.recomendacao.tratamentos)
          .flatMap('insumos')
          .find({ id: $select.id })
          .value();
        $select.dose = produtoOtherCultivar ? produtoOtherCultivar.dose : 0;
        if (produto && produto.length > 0) {
          MessagesService.alert('Este produto já foi inserido na recomendação atual');
        } else {
          const unidade = $select.unidade ? ($select.unidade.descricao_padrao || $select.unidade.descricao) : null;
          $select.unidadeSelected = !unidade ? {} : UnidadesService.getMeasureUnitysFromDescription(unidade);
          produto.unidades = UnidadesService.getUnidadesCompativeis($select.unidadeSelected);
          tratamento.insumos = (tratamento.insumos || []).concat($select);
        }
      }

      vm.produto.selected = null;
      vm.produtos = null;
    }

    function removeProduto(index, tratamento) {
      tratamento.insumos.splice(index, 1);
    }

    function setUnidadeProduto($event, produto, unidade) {
      $event.preventDefault();
      produto.unidadeSelected = unidade;
    }

    function validateProdutos(tratamento) {
      tratamento.insumos = (tratamento.insumos || []).reduce(function(result, produto) {
        if (produto.dose && produto.dose >= MIN_DOSE_VALOR && produto.unidadeSelected &&
            produto.unidadeSelected.conversao) {
          result.push(produto);
        }
        return result;
      }, []);

      const temProdutos = (tratamento.insumos && tratamento.insumos.length > 0);
      return temProdutos;
    }

    const tratamentoModalParams = { operacao_item: 'pulverizacao' };

    function fetchTratamentoProducts(descricao) {
      const params = { ...tratamentoModalParams, ...(descricao ? { descricao } : {}) };
      return RecomendacoesService.listItemsBalance(params)
        .then(function(data) {
          return data.data || [];
        });
    }

    function fetchTratamentoByIds(ids) {
      return RecomendacoesService.listItemsBalance({
        ...tratamentoModalParams,
        item: ids.join(','),
        tipo_item: 1
      }).then(function(data) {
        return data.data || [];
      });
    }

    function openProductModal(tratamento) {
      LoadingService.showLoading();
      RecomendacoesService.listItemsBalance(tratamentoModalParams)
        .then(function(data) {
          return ProdutoModalService.buildModalList(
            data.data, tratamento.insumos, fetchTratamentoByIds
          );
        })
        .then(function(fullList) {
          LoadingService.hideLoading();
          const selectedProducts = ProdutoModalService.findSelected(fullList, tratamento.insumos);
          return ProdutoModalService.open(fullList, selectedProducts, {
            fetchProducts: fetchTratamentoProducts
          });
        })
        .then((products) => ProdutoModalService.mergeProducts(products, tratamento.insumos))
        .then((products) => {
          products.forEach((prod) => vm.addProduto(prod, tratamento));
        })
        .catch(function(error) {
          LoadingService.hideLoading();
          if (error) {
            console.error('Erro ao buscar produtos', error);
            MessagesService.alert('Erro ao carregar produtos');
          }
        });
    }

    function canCopy() {
      return vm.recomendacao.tratamentos.length > 0 && !vm.editing;
    }

    function canSelectCultivarDestino() {
      return vm.cultivaresDestinoDisponivel.length > 1;
    }
  }
}());
